import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "services/stripe";

const withStripe = (Component) => {
  return (props) => {
    return (
      <Elements stripe={stripePromise}>
        <Component {...props} />
      </Elements>
    );
  };
};

export default withStripe;
